import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import {
  FaCheckCircle,
  FaCircleNotch,
  FaExclamationCircle,
  FaInfoCircle
} from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './Firmware.css';

export class Firmware extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equipmentData: [], //This is where all FW data should be stored and referenced
      upArrow: false,
      success: false,
      error: false,
      action: null,
      result: null,
      confirmModal: false,
      collapse: false,
      updateRecomFirmware: this.props.firmwareDisplayUpdateSpinner
        ? this.props.firmwareDisplayUpdateSpinner
        : false,
      updateFailed: false,
    };
    this.resetUpArrow = this.resetUpArrow.bind(this);
    this.updateFirmwareHandler = this.updateFirmwareHandler.bind(this);
  }

  componentDidMount() {
    //this.props.onGetFirmwareUpdate();
  }
  componentWillUpdate() {}
  componentDidUpdate() {
    if (
      !this.state.upArrow &&
      this.props.displayFirmware &&
      !this.state.collapse
    ) {
      this.openHandler();
    }
    //this is where all FW update should be processed
    //this is where all FW update data should be stored and ref
  }

  confirmModalConfirmHandler = () => {
    this.setState({
      updateRecomFirmware: false,
    });
    this.props.onUpdateFirmware();
    setTimeout(() => {
      this.setState({ updateRecomFirmware: true });
    }, 1000);

    this.closeModal();
  };

  updateFirmwareHandler() {
    const modalContent = (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h2 className={classes.showDesktop}>Confirmation of Updating</h2>
        <p style={{ fontWeight: 'normal', textAlign: 'left', margin: '2px' }}>
          This will interrupt connectivity for a few minutes.
        </p>
        <p style={{ fontWeight: 'normal', textAlign: 'left', margin: '5px' }}>
          Are you sure you want to update all equipment firmware?
        </p>
      </div>
    );

    this.onOpenModal(modalContent);
  }
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };
  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  openHandler() {
    this.setState({
      upArrow: true,
      collapse: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetDevicesErrorSuccess();
    this.resetUpArrow();
  };
  resetUpArrow() {
    this.setState({
      upArrow: false,
    });
  }

  render() {
    // var disableFirmwareUpgrade = this.props.firmwareUpdate ? !this.props.firmwareUpdate.upgradeRecommended: true;
    var disableFirmwareUpgrade = false;
    if (
      (this.props.checkingWan && this.props.timerStart) ||
      (this.props.wan &&
        this.props.wan.loaded &&
        this.props.wan.realWan &&
        this.props.wan.realWan.connectionState === 'disconnected') ||
      this.state.updateRecomFirmware

      // || this.props.firmwareUpdate && this.props.firmwareUpdate.summaryState !== 'updated'
      // || this.props.firmwareUpdate && this.props.firmwareUpdate.summaryState !== 'failed'
      // || this.props.firmwareUpdate && this.props.firmwareUpdate.summaryState !== 'skipped'
    ) {
      disableFirmwareUpgrade = true;
    } else {
      disableFirmwareUpgrade = false;
    }

    var firmwareUpgradeTitle;
    if (this.props.firmwareUpdate) {
      firmwareUpgradeTitle = this.props.firmwareUpdate.upgradeRecommended
        ? ''
        : 'There is no Firmware Upgrade Recommended';
    } else {
      firmwareUpgradeTitle = this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : '';
           }

    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    if (this.props.wan && (this.props.wan.loading || !this.props.wan.loaded)) {
      return <Spinner />;
    }

    let tableValues = [];
    let finaldata;
    let equipModelData;
    let equipNameVersionData;
    let spinnerStatus = true;
    let disableCondition = false;

    if (this.props.wan && this.props.wan.loaded && this.props.wan.realWan) {
      let routerValues = {};
      if (this.props.wan.realWan.firmwareVersion) {
        routerValues['version'] = this.props.wan.realWan.firmwareVersion;
      } else {
        routerValues['version'] = 'N/A';
      }

      if (this.props.wan.realWan.model) {
        routerValues['model'] = this.props.wan.realWan.model;
      } else {
        routerValues['model'] = 'N/A';
      }

      routerValues['name'] = 'Router';
      routerValues['id'] = this.props.wan.realWan.id;

      tableValues.push(routerValues);

      if (
        this.props.equipment.loaded &&
        this.props.equipment &&
        this.props.equipment.realEquipment &&
        this.props.equipment.realEquipment.claimedPods
      ) {
        Object.keys(this.props.equipment.realEquipment.claimedPods).forEach(
          (val, ind) => {
            let podValues = {};
            if (
              this.props.equipment.realEquipment.claimedPods[val]
                .firmwareVersion
            ) {
              podValues['version'] =
                this.props.equipment.realEquipment.claimedPods[
                  val
                ].firmwareVersion;
            } else {
              podValues['version'] = 'N/A';
            }
            if (this.props.equipment.realEquipment.claimedPods[val].nickname) {
              podValues['name'] =
                this.props.equipment.realEquipment.claimedPods[val].nickname;
            } else {
              podValues['name'] =
                this.props.equipment.realEquipment.claimedPods[val].defaultName;
            }

            podValues['model'] =
              this.props.equipment.realEquipment.claimedPods[val].model;
            podValues['id'] =
              this.props.equipment.realEquipment.claimedPods[val].id;
            podValues['id'] = podValues['id'].slice(0, 10);
            tableValues.push(podValues);
          }
        );
      }
      equipModelData = Object.keys(tableValues).map((key, value) => {
        return (
          <Box>
            <tr className={classes.trTag}>
              <td style={{ borderLeft: 'none', padding: '10px' }}>
                {tableValues[value].model}
              </td>{' '}
            </tr>
          </Box>
        );
      });
      equipNameVersionData = Object.keys(tableValues).map((key, value) => {
        let progressBar;
        // console.log('research ::::', this.props.firmwareUpdate);
        if (
          this.state.updateRecomFirmware &&
          this.props.firmwareUpdate &&
          this.props.firmwareUpdate.nodes
        ) {
          progressBar = (
            <FaCircleNotch
              fontSize={'15px'}
              style={{ color: '#0073d1' }}
              className={[
                classes.fa,
                classes.facircleonotch,
                classes.faspin,
                classes.fa3x,
                classes.fafw,
              ].join(' ')}
            />
          );
          // console.log(
          //   'nodes Lenght :::',
          //   this.props.firmwareUpdate.nodes.length,
          //   this.props.firmwareUpdateError
          // );
          if (
            this.props.firmwareUpdate.nodes.length === 0 &&
            this.props.firmwareUpdateError
          ) {
            progressBar = '';
          }

          Object.keys(this.props.firmwareUpdate.nodes).forEach((k, val) => {
            if (
              tableValues[value].id ===
              this.props.firmwareUpdate.nodes[val].nodeId
            ) {
              if (
                this.props.firmwareUpdate.nodes[val].state === 'updated' ||
                this.props.firmwareUpdate.nodes[val].state === 'idle' ||
                this.props.firmwareUpdate.nodes[val].state === 'skipped'
              ) {
                spinnerStatus = false;
                progressBar = (
                  <div style={{ display: 'flex' }}>
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaCheckCircle
                        color={'green'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                      Success
                    </p>
                  </div>
                );
              } else if (
                this.props.firmwareUpdate.nodes[val].state === 'failed'
              ) {
                progressBar = (
                  <div style={{ display: 'flex' }}>
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaExclamationCircle
                        color={'red'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                      Failed
                    </p>
                  </div>
                );
                if (!this.state.updateFailed) {
                  this.setState({
                    updateFailed: true,
                  });
                }
              } else {
                disableFirmwareUpgrade = true;
                disableCondition = true;
              }
              // else if(this.props.firmwareUpdate.nodes[val].state === 'idle' ){
              //   progressBar = '';
              // }
            }
          });
        }

        return (
          <Box>
            <tr className={classes.trTag}>
              <td
                className={classes.FirmwareEquipName}
                style={{
                  padding: '10px',
                  borderRight: 'none',
                  borderLeft: 'none',
                }}
              >
                {tableValues[value].name}
              </td>
              <td
                className={classes.FirmwareEquipVersion}
                style={{
                  padding: '10px',
                  borderRight: 'none',
                  borderLeft: 'none',
                }}
              >
                {tableValues[value].version}
              </td>
              <td
                style={{
                  padding: '7px',
                  borderRight: 'none',
                  borderLeft: 'none',
                }}
              >
                {progressBar}
              </td>
            </tr>
          </Box>
        );
      });

      finaldata = Object.keys(tableValues).map((key, value) => {
        let progressBar;
        // console.log(' progress bar props ::', this.props, this.state);
        if (
          this.state.updateRecomFirmware &&
          this.props.firmwareUpdate &&
          this.props.firmwareUpdate.nodes
        ) {
          //if(this.props.firmwareDisplayUpdateSpinner){
          progressBar = (
            <FaCircleNotch
              fontSize={'15px'}
              style={{ color: '#0073d1' }}
              className={[
                classes.fa,
                classes.facircleonotch,
                classes.faspin,
                classes.fa3x,
                classes.fafw,
              ].join(' ')}
            />
          );
          //}
          if (
            this.props.firmwareUpdate.nodes.length === 0 &&
            this.props.firmwareUpdateError
          ) {
            progressBar = '';
          }

          Object.keys(this.props.firmwareUpdate.nodes).forEach((k, val) => {
            if (
              tableValues[value].id ===
              this.props.firmwareUpdate.nodes[val].nodeId
            ) {
              if (
                this.props.firmwareUpdate.nodes[val].state === 'updated' ||
                this.props.firmwareUpdate.nodes[val].state === 'idle' ||
                this.props.firmwareUpdate.nodes[val].state === 'skipped'
              ) {
                progressBar = (
                  <div style={{ display: 'flex' }}>
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaCheckCircle
                        color={'green'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                      Success
                    </p>
                  </div>
                );
              } else if (
                this.props.firmwareUpdate.nodes[val].state === 'failed'
              ) {
                progressBar = (
                  <div style={{ display: 'flex' }}>
                    <p style={{ display: 'flex', alignItems: 'center' }}>
                      <FaExclamationCircle
                        color={'red'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                      Failed
                    </p>
                  </div>
                );
                if (!this.state.updateFailed) {
                  this.setState({
                    updateFailed: true,
                  });
                }
              }
              // else if(this.props.firmwareUpdate.nodes[val].state === 'idle' ){
              //   progressBar = '';
              // }
            }
          });
        }

        return (
          <div
            className={classes.TableInfoRow}
            style={{ borderRadius: '0px 0px 5px 5px' }}
          >
            <div
              id="EquipModel"
              className={classes.TableValueFirst}
              style={{ paddingLeft: '15px' }}
            >
              {tableValues[value].model}
            </div>
            <div
              id="EquipName"
              className={classes.TableValueAreaSmall}
              style={{ paddingLeft: '0px', marginRight: '45px', wordBreak:'break-word' }}
            >
              {tableValues[value].name}
            </div>
            <div
              id="CurrentFirmwareVersion"
              className={classes.TableValueAreaBig}
              style={{ paddingLeft: '0px', marginRight: '10px' }}
            >
              {tableValues[value].version}
            </div>
            <div
              id="FirmWareHeaderAreaTiny"
              className={classes.HeaderAreaTiny}
              style={{ paddingLeft: '15px' }}
            >
              {progressBar}
            </div>
          </div>
        );
      });
      if (!spinnerStatus && !disableCondition) {
        // console.log('disableFirmwareUpgrade ::',disableFirmwareUpgrade, this.state.updateRecomFirmware);
        disableFirmwareUpgrade = false;
      }
    }


  let updateAllBtn;
    if (
      this.state.updateFailed &&
      this.props.firmwareUpdate &&
      this.props.firmwareUpdate.summaryState === 'failed'
    ) {
      updateAllBtn = (
        <div
          className={[classes.TitleArea, classes.firmwareErrMsgMobView].join(
            ' '
          )}
          style={{ display: 'flex' }}
        >
          <p
            className={[classes.firmwareMobMsgStyling]}
            style={{ display: 'flex' }}
          >
            {' '}
            <FaInfoCircle
              color={'red'}
              style={{ marginRight: '10px' }}
              fontSize={'20px'}
            />{' '}
            Firmware update failed, please verify equipment connection and try
            again.
          </p>
          <button
            className={[classes.ActionButton, classes.firmwareBtnMobView].join(
              ' '
            )}
            id="UpdateButton"
            disabled={
              disableFirmwareUpgrade ||
              this.props.optimizeRouterDisplayUpdateSpinner ||
              this.props.originalUpnp?.enabled
            }
            title = {firmwareUpgradeTitle}
            onClick={() => {
              // console.log('CLICKED');
              this.updateFirmwareHandler();
            }}
          >
            Update All
          </button>
        </div>
      );
    } else {
      updateAllBtn = (
        <div className={classes.TitleArea} style={{ float: 'right' }}>
          <button
            className={classes.ActionButton}
            id="UpdateButton"
            disabled={ disableFirmwareUpgrade ||
              this.props.optimizeRouterDisplayUpdateSpinner
               }
            title = {this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''}
            onClick={() => {
              // console.log('CLICKED');
              this.updateFirmwareHandler();
            }}
          >
            Update All
          </button>
        </div>
      );
    }
    let tableData = (
      <Box>
        <div className={classes.InfoRow}>
          <div className={[classes.FirmwareTable].join(' ')}>
            <div
              className={classes.TableHeaderRow}
              style={{ borderRadius: '10px 10px 5px 5px' }}
            >
              <div
                className={classes.HeaderFirst}
                style={{ paddingLeft: '8px' }}
              >
                Equip. Model
              </div>
              <div
                className={classes.HeaderAreaSmall}
                style={{ paddingLeft: '0px', marginRight: '40px' }}
              >
                Equip. Name
              </div>
              <div
                className={classes.HeaderAreaBig}
                style={{ paddingLeft: '0px', marginRight: '12px' }}
              >
                Current Firmware Version
              </div>
              <div
                id="HeaderAreaTiny"
                className={classes.HeaderAreaTiny}
                style={{ paddingLeft: '8px' }}
              ></div>
            </div>
            {finaldata}

            <div
              className={classes.TableEndRow}
              style={{ borderRadius: '0px 0px 5px 5px' }}
            ></div>
          </div>
          {updateAllBtn}
        </div>
        <Modal
          deviceGroupConfirmation="true"
          show={this.state.confirmModal}
          modalClosed={this.closeModal}
        >
          <Confirm
            deviceGroupConfirmation="true"
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Update All"
          />
        </Modal>
        <Modal
          show={this.state.error}
          modalClosed={this.successErrorResetHandler}
        >
          <Error />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success />
        </Modal>
      </Box>
    );
    let defaultCollasibleValue =
      this.state.collapse && this.state.upArrow ? this.state.collapse : false;

    return (
      <Box>
        <div id={this.props.deskId} className={classes.showDesktop}>
          <div className={classes.Firmware}>
            <Collapsible
              transitionTime={100}
              open={defaultCollasibleValue}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div className={classes.FirmwareCollapse}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20, cursor: 'pointer' }}>
                        Firmware
                      </h3>
                      <button
                        id="FirmwareArrow"
                        className={classes.OpenCloseButton}
                        style={{ float: 'right' }}
                        aria-label="open arrow"
                      >
                        {arrow}
                      </button>
                    </div>

                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>
              }
            >
              {tableData}
            </Collapsible>
          </div>
        </div>
        <div id={this.props.mobId} className={classes.showMobile}>
          <div className={classes.Firmware}>
            <Collapsible
              transitionTime={100}
              open={defaultCollasibleValue}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div className={classes.FirmwareCollapse}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20 }}>Firmware</h3>
                      <button
                        className={classes.OpenCloseButton}
                        style={{ float: 'right' }}
                        aria-label="open arrow"
                      >
                        {arrow}
                      </button>
                    </div>

                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>
              }
            >
              <div style={{ float: 'left' }}>
                <table cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th
                        className={classes.HeaderFirst}
                        style={{ borderLeft: 'none', padding: '12px' }}
                      >
                        Equip. Model
                      </th>
                    </tr>
                  </thead>
                  <tbody>{equipModelData}</tbody>
                </table>
              </div>
              <div className={classes.tablewrapper}>
                <table cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th
                        className={classes.HeaderAreaSmall}
                        style={{
                          borderLeft: 'none',
                          borderRight: 'none',
                          textAlign: 'left',
                          padding: '12px',
                        }}
                      >
                        Equip. Name
                      </th>
                      <th
                        className={classes.HeaderAreaBig}
                        style={{
                          borderLeft: 'none',
                          borderRight: 'none',
                          textAlign: 'left',
                          padding: '12px',
                        }}
                      >
                        Firmware Version
                      </th>{' '}
                    </tr>
                  </thead>
                  <tbody>{equipNameVersionData}</tbody>
                </table>
              </div>
              {updateAllBtn}

              <Modal
                firmwareUpdateConfirm={true}
                show={this.state.confirmModal}
                modalClosed={this.closeModal}
              >
                <Confirm
                  id={'FirmwareConfirm'}
                  deviceGroupConfirmation
                  firmwareUpdateConfirm={true}
                  action={this.state.action}
                  result={this.state.result}
                  confirm={this.confirmModalConfirmHandler}
                  cancel={this.confirmModalCancelHandler}
                  cancelButtonLabel="Cancel"
                  confirmButtonLabel="Update All"
                />
              </Modal>
              <Modal
                show={this.state.error}
                modalClosed={this.successErrorResetHandler}
              >
                <Error id={'FirmwareError'} />
              </Modal>
              <Modal
                show={this.state.success}
                modalClosed={this.successErrorResetHandler}
              >
                <Success id={'FirmwareSuccess'} />
              </Modal>
            </Collapsible>
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    firmwareUpdate: state.settings.firmwareUpdate,
    firmwareUpdateLoading: state.settings.firmwareUpdateLoading,
    firmwareUpdateLoaded: state.settings.firmwareUpdateLoaded,
    firmwareUpdateError: state.settings.firmwareUpdateError,
    firmwareDisplayUpdateSpinner: state.settings.firmwareDisplayUpdateSpinner,
    checkingWan: state.wan.checkingWan,
    timerStart: state.wan.timerStart,
    optimizeRouterDisplayUpdateSpinner: state.settings.optimizeRouterDisplayUpdateSpinner,
    originalUpnp: state.upnp.realUpnp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateFirmware: () => dispatch(actions.updateFirmware()),
    onGetFirmwareUpdate: () => dispatch(actions.getFirmwareUpdate())
   };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Firmware, api));
